import React = require("react");

import l10n from "diy/util/l10n";
import $ = require('jquery');

let social: any = require('diy/social/social');

let getFacebookAppId: any = require('diy/social/FacebookAppId');
import websiteData = require('diy/util/websiteData');

interface SocialProps {
    trackingPageName: string;
    showShareMessage?: boolean;
}

export default class Social extends React.Component<SocialProps, {}> {

    private socialMediaPlaceholder: HTMLElement;

    constructor(props: SocialProps) {
        super(props);
    };

    render() {
        const styles = this.getStyles();

        return (
            <div style={styles.root}>
                { this.props.showShareMessage ?
                    <p style={styles.text}>{l10n('maintenance.dialog.share')}</p>
                    : null }
                <div className="diye diy-share-group" ref={(ref) => this.socialMediaPlaceholder = ref}></div>
            </div>
        );
    };

    componentDidMount() {
        social.render(
            this.socialMediaPlaceholder,
            this.shareButtons(l10n('guidedSetup.shareCompletedText'), social.config)
        );
    };

    private getShareUrl() {
        const webUrl = websiteData.getWebUrl();
        let delimiter = '?';

        if (webUrl.indexOf('?') !== -1) {
            delimiter = '&';
        }
        return webUrl + delimiter + (new Date().getTime()).toString();
    }

    private trackEvent(actionName: string) {
        const data = {
            actionName: actionName,
            pageName: this.props.trackingPageName
        };
        $(document).trigger('diy-editor-generic-linkInteraction', data);
    };

    private shareButtons(shareText: string, options: any) {
        const fbAppId = getFacebookAppId();
        return [
            {
                type: 'facebookShare',
                options: {
                    appId: fbAppId,
                    url: this.getShareUrl(),
                    image: websiteData.getCdnUrl() + '/s/diy/congratulations/img/share-fb.png',
                    onClick: () => this.trackEvent('social_facebook'),
                    onSubmit: () => this.trackEvent('social_facebook_success'),
                    onSubmitCanceled: () => this.trackEvent('social_facebook_cancel'),
                    actions: options.facebook.actions
                }
            },
            {
                type: 'twitterShare',
                options: {
                    url: ' ',
                    image: websiteData.getCdnUrl() + '/s/diy/congratulations/img/share-twitter.png',
                    message: {
                        text: shareText
                    },
                    onClick: () => this.trackEvent('social_twitter'),
                    onSubmit: () => this.trackEvent('social_twitter_success')
                }
            },
            {
                type: 'linkedInShare',
                options: {
                    url: this.getShareUrl(),
                    image: websiteData.getCdnUrl() + '/s/diy/congratulations/img/share-linkedin.png',
                    onClick: () => this.trackEvent('social_linkedin')
                }
            },
            {
                type: 'xingShare',
                options: {
                    url: this.getShareUrl(),
                    image: websiteData.getCdnUrl() + '/s/diy/congratulations/img/share-xing.png',
                    onClick: () => this.trackEvent('social_xing')
                }
            }
        ];
    }

    private getStyles() {
        return {
            root: {
                padding: "0 20px"
            },
            text: {
                fontSize: "14px",
                fontWeight: "normal",
                textAlign: "center",
                marginBottom: 0,
                paddingTop: "13px",
                paddingBottom: "13px"
            } as React.CSSProperties
        };
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/moments-to-celebrate/components/Social.tsx
 **/